import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { StyleProps } from '~pricing/components/Ribbon/types';

export default createMemoStyles(({ type, packageTheme }: PricingAppTheme) => ({
  RibbonStyle: {
    fontSize: 10,
    position: 'absolute',
    height: 32,
    top: 0,
    zIndex: pricingElevation.plusOne,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ packageName }: StyleProps) => packageTheme[packageName].primary,
    '& p': {
      fontSize: type.fontSize.body,
      fontWeight: type.fontWeight.medium,
      color: '#fff',
      textAlign: 'center',
      width: '100%',
      display: 'block',
      boxShadow: 'none',
      position: 'absolute',
      margin: 0,
    },
  },
}));
